import { Inject, Injectable, InjectionToken } from '@angular/core';
import { OauthResponseTypes, Product } from '@ktypes/enums';
import { envVariables, latestVersion, versions } from './environment-variables';

export const CONFIG = new InjectionToken<EnvironmentConfig>('EnvironmentConfig');

export interface Versions {
  npm_version?: string;
  app?: {
    purposeful?: string;
    resourceful?: string;
    insightful?: string;
  };
  revision?: string;
  branch?: string;
}

export interface EnvironmentConfig {
  production?: boolean;
  apiHostUrl?: string;
  appUrls?: {
    insightful?: string;
    purposeful?: string;
    resourceful?: string;
  };
  bugLink?: string;
  environment?: string;
  feedbackLink?: string;
  hostname?: string;
  version?: number;
  oauth: {
    authClientSsoId: string;
    authClientSocialId: string;
    clientId: string;
    domain: string;
    redirectSignIn: string;
    redirectSignOut: string;
    responseType: OauthResponseTypes;
  };
}

@Injectable({
  providedIn: 'root',
})
export class EnvironmentVariablesService {
  constructor(@Inject(CONFIG) private _environmentConfig: EnvironmentConfig) {}

  get config(): EnvironmentConfig {
    return this._environmentConfig;
  }

  get circleTag(): Product {
    return envVariables?.CIRCLE_TAG as Product;
  }

  get product(): Product {
    return envVariables?.PRODUCT as Product;
  }

  get versions(): Versions {
    return versions;
  }

  get latestVersion(): string {
    return latestVersion;
  }

  get appVersion(): string {
    return versions?.app?.[envVariables.PRODUCT];
  }
}

export class MockPurposefulEnvVariable {
  product = 'purposeful';
}

export class MockResourcefulEnvVariable {
  product = 'resourceful';
}
